import noop from 'lodash/noop';
import { ITextProps, Text } from 'native-base';
import React, { useMemo } from 'react';
import { Linking, Pressable } from 'react-native';

export type TextLinkProps = ITextProps & {
  children: string | string[];
  url?: string;
  color?: string;
  onPress?: () => void;
  testID?: string;
  disabled?: boolean;
};

export default function TextLink({
  children,
  url,
  color = 'black',
  onPress,
  testID,
  disabled,
  ...props
}: TextLinkProps) {
  const handlePress = useMemo(() => {
    if (disabled) return noop;
    if (onPress) return onPress;
    if (url) return () => Linking.openURL(url);
    return noop;
  }, [disabled, onPress, url]);

  return (
    <Pressable
      accessibilityLabel={testID}
      accessibilityRole={url ? 'link' : 'button'}
      disabled={disabled}
      testID={testID}
      onPress={handlePress}
    >
      <Text
        {...props}
        color={color}
        fontFamily={props.bold === false ? 'ProximaNova' : 'ProximaNova-Bold'}
        underline
      >
        {children}
      </Text>
    </Pressable>
  );
}
